// @ts-nocheck
import React, { useEffect } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRedirect,
  useRefresh,
  SaveButton,
  Toolbar,
  useRecordContext,
  DateTimeInput,
  ArrayInput,
  SelectInput,
  SelectArrayInput,
  FunctionField
} from "react-admin";
import { makeStyles } from "@mui/styles";
import { Box, Card, CardMedia, Grid, IconButton, Stack, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { dataProvider } from "../../../provider";
import Swal from "sweetalert2";
import DeleteIcon from '@mui/icons-material/Delete';
import { RichTextInput } from "ra-input-rich-text";

const useStyles = makeStyles({
  input: {
    marginBottom: "-20px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
});

const CurrentImage = () => {
  const record = useRecordContext();
  if (!record) return null;
  return (
    <>
      <p>Image</p>
      <Card sx={{ display: "inline-block" }}>
        <CardMedia
          component="img"
          image={record.content.image}
          alt={record.content.title}
        />
      </Card>
    </>
  );
};

export const EditBroadcast = ({ onCancel, id, ...props }) => {
  const classes = useStyles();

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        onCancel();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [onCancel]);

  const notify = useNotify();
  const redirect = useRedirect();
  const refresh = useRefresh();

  const onSubmitHandler = async (data) => {
    const resp = await dataProvider.update("promotionsBroadcast", { data, id })
    if (resp.data) {
      notify("success edit data", {
        type: "success",
        messageArgs: { smart_count: 1 },
        undoable: false,
      });
    } else {
      notify(resp.error.message, {
        type: "error",
        messageArgs: { smart_count: 1 },
        undoable: false,
      });
    }
    redirect(`/promotions/broadcast`);
    refresh();
  };

  const onDeleteHandler = async (data) => {
    if (data.is_sent === true) {
      await dataProvider.update("promotionsBroadcast", { data: { is_deleted: true }, id: data.id }).then(() => {
        notify("ra.notification.created", {
          type: "info",
          messageArgs: { smart_count: 1 },
          undoable: true,
        });
        redirect(`/promotions/broadcast`);
        refresh();
        Swal.fire("Success Delete Broadcast!", "", "success");
      });
    } else {
      await dataProvider.delete("promotionsBroadcast", { id: data.id }).then(() => {
        notify("ra.notification.created", {
          type: "info",
          messageArgs: { smart_count: 1 },
          undoable: true,
        });
        redirect(`/promotions/broadcast`);
        refresh();
        Swal.fire("Success Delete Broadcast!", "", "success");
      });
    }
  };

  const confirmDelete = (record) => {
    Swal.fire({
      title: 'Are you sure to delete this broadcast?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        onDeleteHandler(record);
      }
    });
  };

  const ToolbarEdit = () => {
    const record = useRecordContext();
    const classes = useStyles();

    return (
      <Toolbar className={classes.toolbar}>
        <SaveButton />
        <Button variant="contained" color="error" startIcon={<DeleteIcon />} onClick={() => confirmDelete(record)}>
          Delete
        </Button>
      </Toolbar>
    );
  };

    const typeList = [
    { id: "M21_ALL_SUBSCRIBERS", name: "M21 - ALL SUBSCRIBERS" },
    { id: "M21_ALL_SUBSCRIBERS_HK", name: "M21 - HONG KONG SUBSCRIBERS" },
    { id: "M21_ALL_SUBSCRIBERS_TW", name: "M21 - TAIWAN SUBSCRIBERS" },
    { id: "M21_ALL_SUBSCRIBERS_MY", name: "M21 - MALAYSIA SUBSCRIBERS" },
    { id: "M21_ALL_SUBSCRIBERS_ID", name: "M21 - INDONESIA SUBSCRIBERS" },
    { id: "M21_VN_SUBSCRIBERS", name: "M21 - ALL SUBSCRIBERS (HAVE VN)" },
    { id: "M21_NON_VN_SUBSCRIBERS", name: "M21 - ALL SUBSCRIBERS (DO NOT HAVE VN)" },
    { id: "G2_ALL_SUBSCRIBERS", name: "G2 - ALL SUBSCRIBERS" },
    { id: "GHK_ALL_SUBSCRIBERS", name: "Grapari HK - ALL SUBSCRIBERS" },
    { id: "GHK_PREPAID_SUBSCRIBERS", name: "Grapari HK - Prepaid" },
    { id: "GHK_POSTPAID_SUBSCRIBERS", name: "Grapari HK - Postpaid" },
    { id: "HASH_TS", name: "HASH - TS TEAM" },
    { id: "CUSTOM", name: "CUSTOM TARGET" },
  ];

  return (
    <Edit resource="promotionsBroadcast" title=" &rsaquo; Edit" {...props}>
      <Box
        pt={5}
        width={{ xs: "100vW", sm: 600 }}
        mt={{ xs: 2, sm: 1 }}
        height="120vh"
      >
        <Stack
          direction="row"
          p={0}
          sx={{ position: "absolute", right: 0, zIndex: 100 }}
        >
          <IconButton onClick={onCancel} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
        <SimpleForm onSubmit={onSubmitHandler} toolbar={<ToolbarEdit />}>
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <CurrentImage />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  fullWidth
                  className={classes.input}
                  source="content.title"
                  data-testid="content-title"
                  label="Title"
                  validate={required()}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DateTimeInput fullWidth source="scheduled_at" label="Schedule At" />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  fullWidth
                  className={classes.input}
                  source="content.url"
                  data-testid="content-url"
                  label="URL"
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <SelectInput
                  fullWidth
                  className={classes.input}
                  source="content.topic"
                  choices={typeList}
                  label="Target"
                  data-test-id="type"
                  optionValue="id"
                disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  fullWidth
                  className={classes.input}
                  source="content.content"
                  data-testid="content-content"
                  label="Content"
                  validate={required()}
                />
              </Grid>
            </Grid>
          </div>
        </SimpleForm>
      </Box>
    </Edit>
  );
};
